import React, { useContext, useEffect, useState } from 'react';
import { useModuleContext } from '../../context/ModuleProvider';
import { FaCalendarAlt, FaClock, FaCrown } from 'react-icons/fa';
import Preloader from '../Preloader/Preloader';
import { useParams, Link } from 'react-router-dom';
import { MeetingContext } from '../../context/MeetingContextProvider';
import { decrypt } from '../../service/Encryption';
import { toast } from 'react-toastify';
import moment from 'moment';
import './Live.css';
import axiosInstance from '../../axiosapi';
import { CiChat1 } from 'react-icons/ci';
import Tooltip from '../Tooltip/Tooltip';

function Live() {
  const { setMeeting } = useContext(MeetingContext);
  const [isLoading, setIsLoading] = useState(true);
  const [userLiveGroup, setUserLiveGroup] = useState([]);
  const { moduleId } = useParams();
  const { url, currentModule } = useModuleContext();
  const isMobile = window.innerWidth < 767;
  let expireDate = moment.utc(currentModule.expireDate);
  let remainTime = expireDate.diff(moment.utc());
  let expired = !(remainTime > 0);

  useEffect(() => {
    axiosInstance({
      method: 'get',
      url: `${url}/zoom/haslivegroup-access`,
    })
      .then((res) => {
        let data = decrypt(res.data.liveGroups);
        data = JSON.parse(data);
        setUserLiveGroup(data);
      })
      .catch((error) => {
        toast.error(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const allLives = userLiveGroup.flatMap((group) => group.lives || []);
  const upcomingItems = allLives.filter((item) => !item.is_live);
  const liveItems = allLives.filter((item) => item.is_live);

  return !isLoading ? (
    <section className="content zoom-live">
      {!isMobile && expired && (
        <div className="live-subscribe">
          <div className="texts">
            <h1>Introducing Best Live Subscription Plans!</h1>
            <p>Take Your Preparation to Next Level & Discover more today !!</p>
          </div>
          <Link to={`/${moduleId}/payment?type=zoomplan`} className="buy-now-btn">
            Buy Now
          </Link>
        </div>
      )}

      <div className="live-contents">
        {liveItems.length > 0 || upcomingItems.length > 0 ? (
          <>
            {/* Live Classes */}
            {liveItems.length > 0 && (
              <>
                <div className="top-heading">
                  <h2>Live Classes</h2>
                  <p>Attend interactive live sessions with top educators</p>
                </div>
                <div className="live-classes ">
                  <div className="meeting-lives live-class">
                    {liveItems.map((item, i) => {
                      const start_date = moment(item.start_time).format('MMM DD, YYYY');
                      const s_time = moment(item.start_time).format(' hh:mm A');
                      return (
                        <div className="live-item" key={`live-${i}`}>
                          <div className="content">
                            {item.status !== 'CANCELLED' && item.status !== 'ENDED' && (
                              <div className="live-status is-live">
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
                                  <circle cx="8" cy="8.5" r="8" fill="#FFC2C2" />
                                  <circle cx="8" cy="8.5" r="3.75" fill="#D92626" stroke="white" strokeWidth="0.5" />
                                </svg>
                                <>LIVE</>
                              </div>
                            )}
                            <article className="details">
                              <div className="d-flex justify-content-between align-items-start w-100">
                                <p className="premium">
                                  <FaCrown /> Premium
                                </p>
                                {(item.status === 'CANCELLED' || item.status === 'ENDED') && (
                                  <div className={`live-status`}>
                                    <Tooltip text={item.cancel_reason} position="top">
                                      <span
                                        className={`status ${
                                          item.status === 'CANCELLED' || item.status === 'ENDED' ? 'is-canceled' : ''
                                        }`}
                                        title={item.status === 'CANCELLED' ? `${item.cancel_reason}` : ''}
                                      >
                                        {item.status}
                                        {item.status === 'CANCELLED' && (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                          >
                                            <g fill="currentColor">
                                              <path d="M9 11a1 1 0 1 1-2 0a1 1 0 0 1 2 0M7.5 4A2.5 2.5 0 0 0 5 6.5h2a.5.5 0 0 1 .5-.5h.646a.382.382 0 0 1 .17.724L7 7.382V9h2v-.382l.211-.106A2.382 2.382 0 0 0 8.146 4z" />
                                              <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2" />
                                            </g>
                                          </svg>
                                        )}
                                      </span>
                                    </Tooltip>
                                  </div>
                                )}
                              </div>
                              <h1>{item.title}</h1>
                              {item.description && <div dangerouslySetInnerHTML={{ __html: item.description }}></div>}

                              <div
                                style={{
                                  display: 'flex',
                                  gap: '1rem',
                                  alignItems: 'center',
                                  fontSize: '12px',
                                  color: 'gray',
                                  justifyContent: 'center',
                                }}
                              >
                                <div>
                                  <FaCalendarAlt style={{ marginRight: '5px' }} />
                                  {start_date}
                                </div>
                                <div>
                                  <FaClock style={{ marginRight: '5px' }} />
                                  {s_time}
                                </div>
                              </div>
                            </article>
                            <div className="buttons">
                              <div className="join-live">
                                <Link
                                  to={item.status === 'CANCELLED' || item.status === 'ENDED' ? '#' : `/live/meeting`}
                                  onClick={() =>
                                    setMeeting({
                                      meetingId: item.meet_id,
                                      meetingPw: item.meet_pass,
                                      meetingMsdkKey: item.zoom_msdk_key,
                                      isWebinar: item.meet_type === 5,
                                    })
                                  }
                                >
                                  Join Live Class
                                </Link>
                              </div>

                              <div className="join-video">
                                <div className="doubt">
                                  <Link to={`/${moduleId}/ask-a-teacher`}>
                                    <span
                                      style={{
                                        display: 'flex',
                                        gap: '10px',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <CiChat1 size={18} />
                                      <p className="p-0">Ask a Doubt</p>
                                    </span>
                                  </Link>
                                  {item.subjects.length && item.subjects[0].id ? (
                                    <Link
                                      className="video-resource"
                                      style={{ padding: '10px' }}
                                      to={`/${moduleId}/practice/unitDetail/?subjectId=${item.subjects[0].subject_id}`}
                                    >
                                      Videos
                                    </Link>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="meeting-lives-right">
                    <div style={{ display: 'flex', flexDirection: 'column', padding: '6px' }}>
                      <p style={{ fontSize: '14px', fontWeight: 'bold', justifyItems: 'center' }}>
                        Live Class Guidlines
                      </p>
                      <p className="descriptions">
                        Students should attend online classes on time, stay prepared, and maintain respectful behavior
                        throughout the session. Microphones should remain muted when not speaking, and active
                        participation through chat or discussions is encouraged. Students should also ensure a stable
                        internet connection and a quiet environment for effective learning. In case of any technical
                        issues, students should reach out to the support team for assistance.
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Upcoming Classes */}
            {upcomingItems.length > 0 && (
              <>
                <h4 style={{ fontWeight: '600' }}>Upcoming Classes</h4>
                <div className="meeting-lives">
                  {upcomingItems.map((item, i) => {
                    const start_date = moment(item.start_time).format('MMM DD, YYYY');
                    const s_time = moment(item.start_time).format('hh:mm A');
                    return (
                      <div className="live-item" key={`upcoming-${i}`}>
                        <div className="content">
                          <article className="details">
                            <p className="premium">
                              <FaCrown /> Premium
                            </p>
                            <h1>{item.title}</h1>
                            <div
                              style={{
                                display: 'flex',
                                gap: '1rem',
                                alignItems: 'center',
                                fontSize: '12px',
                                color: 'gray',
                                justifyContent: 'center',
                              }}
                            >
                              <div>
                                <FaCalendarAlt style={{ marginRight: '5px' }} />
                                {start_date}
                              </div>
                              <div>
                                <FaClock style={{ marginRight: '5px' }} />
                                {s_time}
                              </div>
                            </div>

                            {item.description && <div dangerouslySetInnerHTML={{ __html: item.description }}></div>}
                          </article>

                          {item.subjects.length && item.subjects[0].id ? (
                            <>
                              <div className="buttons">
                                <Link
                                  className=""
                                  to={`/${moduleId}/practice/unitDetail/?subjectId=${item.subjects[0].subject_id}`}
                                >
                                  Videos
                                </Link>
                              </div>
                            </>
                          ) : (
                            <div className="buttons">
                              <Link className="not-allowed" to="#">
                                Offline
                              </Link>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </>
        ) : (
          <BuyLiveClass moduleId={moduleId} />
        )}
      </div>
    </section>
  ) : (
    <Preloader />
  );
}

const BuyLiveClass = ({ moduleId }) => {
  const isMobile = window.innerWidth < 767;
  return (
    <div className="buy-online-class">
      <div>
        <img src="/images/buy-online-class.svg" alt="Buy" height="350px" />
        <div className="buy-now">
          <p>You do not have any Live Group assigned to your name.</p>
          {isMobile && <Link to={`/${moduleId}/payment?type=zoomplan`}>Buy Now</Link>}
        </div>
      </div>
    </div>
  );
};

export default Live;
